<template>
  <div>
    <div v-if="releaseForms.length > 0">
      <b-button-toolbar>
        <div v-for="form in releaseForms">
          <b-button-group class="mr-1 mb-1">
            <b-button variant="secondary"
                      size="sm"
                      :href="form.url"
                      v-b-tooltip
                      :title="formTip(form)"
                      class="d-flex flex-column align-items-start"
                      target="_blank">
              {{ formName(form) }}
            </b-button>
            <b-button v-if="!readonly"
                      variant="secondary" size="sm"
                      @click="handleReleaseFormRemove(form)">
              <i class="fas fa-times"/>
            </b-button>
          </b-button-group>
        </div>
      </b-button-toolbar>
    </div>

    <div v-else-if="!releaseRequired">
      <b-button-group>
        <b-button disabled variant="secondary" size="sm">No Release Needed</b-button>
        <b-button v-if="!readonly" variant="secondary" size="sm" @click="handleReleaseRequiredToggle">
          <i class="fas fa-times"/>
        </b-button>
      </b-button-group>
    </div>

  </div>
</template>

<script>
import startCase from "lodash/startCase";

export default {
  props: ['assetsUrl', 'asset', 'readonly', 'initialReleaseForms', 'onlyTriggerChanges'],

  data: function () {
    return {
      releaseRequired: this.asset.release_required,
      releaseForms: this.initialReleaseForms || []
    }
  },

  mounted: function () {
    this.emitReleaseRequired();
  },

  watch: {
    initialReleaseForms: function (val) {
      this.releaseForms = val || [];
      if (this.releaseForms.length > 0) {
        this.releaseRequired = true
      }
    },

    releaseRequiredEditable: function () {
      this.emitReleaseRequired();
    },

    releaseRequired: function (val) {
      this.$emit('releaseRequiredChanged', val)
    },

    releaseForms: function (val) {
      this.$emit('releaseFormsChanged', val)
    }
  },

  computed: {
    releaseRequiredEditable: function () {
      return this.releaseRequired && this.releaseForms.length === 0
    }
  },

  methods: {
    emitReleaseRequired: function () {
      this.$emit('releaseRequiredEditableChanged', this.releaseRequiredEditable)
    },

    handleReleaseRequiredToggle: function () {
      if (this.onlyTriggerChanges) {
        this.releaseRequired = !this.releaseRequired
      } else {
        this.$http.patch(`${this.assetsUrl}/${this.asset.id}`, {
          asset: {
            release_required: !this.releaseRequired
          }
        }).then(fulfilled => {
          this.releaseRequired = !this.releaseRequired;
        });
      }

    },

    handleReleaseFormRemove: function (releaseForm) {
      if (this.onlyTriggerChanges) {
        this.$emit('removedReleaseForm', releaseForm)
      } else {
        const releaseFormIds = this.releaseForms.map(f => f.id);
        releaseFormIds.splice(releaseFormIds.indexOf(releaseForm.id), 1);

        this.$http.patch(`${this.assetsUrl}/${this.asset.id}`, {
          asset: {
            release_form_ids: releaseFormIds
          }
        }).then(fulfilled => {
          this.releaseForms.splice(this.releaseForms.indexOf(releaseForm), 1)
        });
      }
    },

    formName(form) {
      return startCase(form.release_type)
    },

    formTip(form) {
      return form.name
    }
  }
}
</script>